/*
  <drawer-nav-tabs> — the tab bar at the top of the mobile menu drawer.

  Markup (rendered by header-drawer.liquid):
    <drawer-nav-tabs>
      <div role="tablist">
        <button role="tab" class="drawer-tabs__tab" aria-controls="…" aria-selected="true|false">
        <a class="drawer-tabs__tab" href="…">           (plain link tabs: no panel)
      </div>
      <div role="tabpanel" id="…" [hidden]>
    </drawer-nav-tabs>

  Behaviour follows the WAI-ARIA tabs pattern: click or Enter/Space
  selects, Left/Right/Home/End move between tabs with automatic
  activation, only the selected tab is in the Tab order (roving
  tabindex). Server-rendered state is respected — whichever tab the
  Liquid marked aria-selected="true" is the one that shows on open, so
  the drawer works before this script runs.

  These buttons carry .drawer-tabs__tab so Dawn's MenuDrawer skips them
  in its "any button closes the submenu" binding (global.js).
*/
(function () {
  'use strict';

  class DrawerNavTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, tab));
      });

      const current = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.select(current, { focus: false });
    }

    panelFor(tab) {
      const id = tab.getAttribute('aria-controls');
      return id ? this.querySelector('#' + CSS.escape(id)) : null;
    }

    select(tab, opts) {
      const focus = !opts || opts.focus !== false;
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        const panel = this.panelFor(t);
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    onKeydown(e, tab) {
      const i = this.tabs.indexOf(tab);
      let next = null;
      switch (e.key) {
        case 'ArrowRight': next = this.tabs[(i + 1) % this.tabs.length]; break;
        case 'ArrowLeft':  next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length]; break;
        case 'Home':       next = this.tabs[0]; break;
        case 'End':        next = this.tabs[this.tabs.length - 1]; break;
        default: return;
      }
      e.preventDefault();
      this.select(next);
    }
  }

  if (!customElements.get('drawer-nav-tabs')) {
    customElements.define('drawer-nav-tabs', DrawerNavTabs);
  }
})();
